import { useEffect, useState } from "react";
import { BRAND_LOGO_URL, BRAND_ICON_URL, api } from "@/lib/api";

/**
 * Renders the official Global Seed Foundation brand mark.
 * variant: "full" (large white/light square logo) | "icon" (small square app icon)
 */
export function Logo({ variant = "full", className = "", size = 80 }) {
    const [brandReady, setBrandReady] = useState(true);

    useEffect(() => {
        let cancelled = false;
        api.get("/brand")
            .then(({ data }) => {
                if (cancelled) return;
                if (variant === "icon") setBrandReady(!!data.icon_uploaded);
                else setBrandReady(!!data.logo_uploaded);
            })
            .catch((err) => {
                // Non-fatal: fall back to rendering the asset URL directly; browser will 404 gracefully.
                // eslint-disable-next-line no-console
                console.warn("Brand asset status probe failed:", err?.message || err);
                if (!cancelled) setBrandReady(true);
            });
        return () => {
            cancelled = true;
        };
    }, [variant]);

    const src = variant === "icon" ? BRAND_ICON_URL : BRAND_LOGO_URL;
    const alt =
        variant === "icon"
            ? "Global Seed Foundation official icon"
            : "Global Seed Foundation Warren Park Connect official logo";

    if (!brandReady) {
        return (
            <div
                data-testid="brand-placeholder"
                className={`inline-flex items-center justify-center rounded-xl bg-[color:var(--gsf-soft-green)] border border-dashed border-[color:var(--gsf-green-600)] text-[color:var(--gsf-green-700)] text-[10px] uppercase tracking-widest font-bold px-3 ${className}`}
                style={{ width: size, height: size }}
            >
                Awaiting official brand asset
            </div>
        );
    }

    return (
        <img
            data-testid={variant === "icon" ? "site-icon" : "site-logo"}
            src={src}
            alt={alt}
            width={size}
            height={size}
            style={{ width: size, height: size, objectFit: "contain" }}
            className={className}
            loading="eager"
        />
    );
}
